import { render, staticRenderFns } from "./CloudContactUnit.vue?vue&type=template&id=2a70352d&"
import script from "./CloudContactUnit.vue?vue&type=script&lang=js&"
export * from "./CloudContactUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports